export class ResourceUtils {
  static TYPES = {
    device: 'device',
    app: 'app',
    manager: 'manager',
  };

  static getOwnerUriFromId(resource) {
    const parts = resource.id.split(':');
    parts.pop();
    return parts.join(':');
  }

  static splitKey(key) {
    const split = key.split('::');

    if (split.length === 1) {
      return [null, split[0]];
    }

    return split;
  }

  static getOwnerId(resource) {
    return ResourceUtils.getOwnerTypeAndIdFromOwnerUri(resource?.ownerUri).id;
  }

  static getOwnerType(resource) {
    return ResourceUtils.getOwnerTypeAndIdFromOwnerUri(resource?.ownerUri).type;
  }

  static getOwnerName(resource) {
    return resource?.ownerName ?? resource?.uriObj?.name ?? null;
  }

  static getOwnerTypeAndIdFromOwnerUri(ownerUri) {
    if (ownerUri == null) {
      return {
        type: null,
        id: null,
      };
    }

    // homey:app:com.athom.homey:whatever
    const regex = /^homey:(?<type>app|manager|device|zone|logic|mood|user):(?<id>[^:]+)$/;
    const match = ownerUri.match(regex);

    // type = app
    // id = com.athom.homey

    if (match == null) {
      return {
        type: null,
        id: null,
      };
    }

    return { id: match.groups.id, type: match.groups.type };
  }

  static getOwnerProps(resource) {
    if (resource == null) {
      return {
        ownerUri: null,
        ownerId: null,
        ownerType: null,
      };
    }

    const { id, type } = ResourceUtils.getOwnerTypeAndIdFromOwnerUri(resource?.ownerUri);

    return {
      ownerUri: resource?.ownerUri,
      ownerId: id,
      ownerType: type,
    };
  }
}
